import React from "react";
import { defineMessages, useIntl } from "react-intl";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "theme/components/atoms/Icon";

const MAX_RATING = 5;

const messages = defineMessages({
  rating: {
    id: "components.molecules.stars.rating",
    defaultMessage: "Rated: {rating}/5",
  },
});

const Stars = ({ size, rating, onClick }) => {
  const intl = useIntl();
  const roundedRating = Math.round(rating * 2) / 2;

  const iconSize = size === "small" ? "mini" : "small";

  return (
    <div
      className={classNames("stars", { "stars--clickable": onClick })}
      title={intl.formatMessage(messages.rating, {
        rating: rating.toFixed(1),
      })}
    >
      <div className="stars__fill">
        {new Array(Math.floor(roundedRating)).fill(null).map((_, index) => {
          return (
            <span key={index} className="stars__icon">
              <Icon size={iconSize} icon="star" title="" />
            </span>
          );
        })}
        {Math.floor(roundedRating) < roundedRating && (
          <span className="stars__icon">
            <Icon size={iconSize} icon="star-half" title="" />
          </span>
        )}
      </div>
      <div className="stars__empty">
        {new Array(MAX_RATING).fill(null).map((_, index) => {
          return (
            <span
              key={index}
              className="stars__icon"
              onClick={() => {
                onClick(index + 1);
              }}
            >
              <Icon size={iconSize} icon="star" title="" />
            </span>
          );
        })}
      </div>
    </div>
  );
};

Stars.propTypes = {
  rating: PropTypes.number.isRequired,
  iconSize: PropTypes.oneOf(["default", "small"]),
};

export default Stars;
